import styled from 'styled-components';
import { Label } from '../../../../Components/uielements';

export const CompanyContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`;

export const ModalGap = styled.div`
  display: grid;
  gap: 25px;
`;

export const TableCell = styled.div`
  cursor: pointer;
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  min-width: 500px;
`;

export const ContentWrapper = styled.div`
  margin: auto;
  min-width: 400px;
  display: grid;
  gap: 10px;
  display: grid;
  place-items: center;
`;

export const ModalWrapperTwoColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 28px;
  padding: 10px 20px 30px;
  min-width: 860px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    min-width: unset;
  }
`;

export const MapSection = styled.div`
  display: grid;
  gap: 8px;
  align-content: start;
`;

export const MapSectionTitle = styled(Label)``;

export const MapContainerBox = styled.div`
  width: 100%;
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dcdcdc;
  position: relative;
`;

export const MapSearchInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 9px 12px;
  border-radius: 6px;
  border: 1px solid #dcdcdc;
  font-size: 13px;
  outline: none;

  &:focus {
    border-color: #0071e3;
  }
`;

export const MapInfoBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
  color: #555;
  background: #f7f7f7;
  border-radius: 6px;
  padding: 7px 10px;
`;

export const MapCoordinatesText = styled(Label)`
  font-size: 12px;
  color: #000;
`;

export const MapRemovePinButton = styled.button`
  border: none;
  background: transparent;
  color: #d9534f;
  font-size: 12px;
  cursor: pointer;
  font-weight: 600;
  padding: 0;

  &:disabled {
    color: #aaa;
    cursor: not-allowed;
  }
`;
